var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.token)?[(_vm.user)?[_c('router-view')]:[(_vm.error)?_c('error-page',{attrs:{"error":_vm.error,"statusCode":_vm.statusCode}}):_c('page-loader')]]:_c('h2',{staticClass:"text-center"},[_vm._v("Link is invalid")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }